<p-dialog [style]="{width: '98vw'}" [contentStyle]="{'padding':'0 1.5rem 1.5rem 1.5rem'}" [(visible)]="display" appendTo="body" [modal]="true" [closeOnEscape]="false" (onShow)="showDialog($event)" (onHide)="hideDialog($event)">
  <div *ngIf="isLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-header>
    {{'Address.Confirmation' | translate}} ({{currentIndex}}/{{doNos.length}}): {{currentDoNo}}
  </p-header>
  <div style="margin-top: 1rem;">
    <p-radioButton name="groupname" value="1" [label]="'Address.Radio.Similar' | translate" [(ngModel)]="confirmType"></p-radioButton>
    <p-radioButton class="ml-2" name="groupname" value="2" [label]="'Address.Radio.NewAddress' | translate" [(ngModel)]="confirmType"></p-radioButton>
  </div>

  <!-- TODO GBG 上線時補上：條件要加 && !isGbgFTermExport，
       因為批次套用只寫 deliveryTo 那半，GBG F-Term Export 的 DO 還需要 Consignee 那半 -->
  <div class="ml-1 same-address-badge" *ngIf="sameAddressCandidates.length > 0" style="margin-top: 0.5rem;" (click)="showSameAddressDialog = true">
    <i class="pi pi-link"></i>
    <span>{{getSameAddressBadgeText()}} <span class="same-address-badge-count">{{sameAddressCandidates.length}}</span></span>
    <span *ngIf="selectedSameAddressDoNos.length > 0">（{{'Address.SameAddress.SelectedCount' | translate}} {{selectedSameAddressDoNos.length}}）</span>
    <span class="same-address-badge-action">{{'Address.SameAddress.Button.View' | translate}} <i class="pi pi-chevron-right"></i></span>
  </div>

  <div *ngIf="confirmType == 1 then mergeAddressContentHeader else insertAddressContentHeader"></div>
  <ng-template #mergeAddressContentHeader>
    <div style="overflow: hidden; margin-top: 1rem; margin-bottom: 1rem;">
      <div class="ml-1">
        {{'Address.Header.DeliveryType' | translate}} <b>{{currentDeliveryType}}</b>
      </div>
      <div class="ml-1">
        {{'Address.Header.DeliveryCompany' | translate}} <b>{{currentCompany}}</b>
        <button type="button" class="copy-inline-btn" pButton icon="pi pi-copy" (click)="copyToClipboard(currentCompany)" [attr.aria-label]="'Common.Button.Copy' | translate"></button>
      </div>
      <div class="ml-1">
        {{'Address.Header.Description1' | translate}} <b>{{currentAddress}}</b>
        <button type="button" class="copy-inline-btn" pButton icon="pi pi-copy" (click)="copyToClipboard(currentAddress)" [attr.aria-label]="'Common.Button.Copy' | translate"></button>
        {{'Address.Header.Description2' | translate}}
      </div>
    </div>
  </ng-template>

  <ng-template #insertAddressContentHeader>
    <div style="margin-top: 1rem;">
      <div class="ml-1">
        {{'Address.Header.DeliveryCompany' | translate}} <b>{{currentCompany}}</b>
        <button type="button" class="copy-inline-btn" pButton icon="pi pi-copy" (click)="copyToClipboard(currentCompany)" [attr.aria-label]="'Common.Button.Copy' | translate"></button>
      </div>
      <div class="ml-1">
        {{'Address.Header.Description1' | translate}} <b>{{currentAddress}}</b>
        <button type="button" class="copy-inline-btn" pButton icon="pi pi-copy" (click)="copyToClipboard(currentAddress)" [attr.aria-label]="'Common.Button.Copy' | translate"></button>
        {{'Address.Header.Description3' | translate}}
      </div>
    </div>
  </ng-template>

  <div *ngIf="confirmType == 1 then mergeAddressContent else insertAddressContent"></div>
  <ng-template #mergeAddressContent>
    <div class="address-table-scroll" style="max-height: 400px; overflow: auto; padding-bottom: 1.5rem;">
      <p-table class="datatable" [value]="recommendations" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col style="width:3%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:8%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:8%">
            <col style="width:10%">
            <col style="width:9%">
            <col style="width:8%">
            <col style="width:9%">
            <col style="width:7%">
            <col style="width:7%">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th colspan="3" style="text-align: center;">{{'Address.Radio.Similar' | translate}}</th>
            <th colspan="9" style="text-align: center;">{{'Address.Radio.NormalizationAddress' | translate}}</th>
          </tr>
          <tr>
            <th>{{'Address.Header.Option' | translate}}</th>
            <th>{{'Address.Header.CustomerName' | translate}}</th>
            <th>{{'Address.Header.ConsigneeCompany' | translate}}</th>
            <th>{{'Address.Header.ReferenAddress' | translate}}</th>
            <th>{{'Address.Header.GroupId' | translate}}</th>
            <th>{{'Address.Header.Country' | translate}}</th>
            <th>{{'Address.Header.City' | translate}}</th>
            <th>{{'Address.Header.DeliveryToLocal' | translate}}</th>
            <th>{{'Address.Header.NormalizationLocal' | translate}}</th>
            <th>{{'Address.Header.DeliveryToEng' | translate}}</th>
            <th>{{'Address.Header.NormalizationEng' | translate}}</th>
            <th>{{'Address.Header.AssignmentDistricId' | translate}}</th>
            <th>{{'Address.Header.Airport' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-address>
          <tr>
            <td>
              <p-radioButton name="address" value="{{address.SeqNo}}" [(ngModel)]="chooseAddress"></p-radioButton>
            </td>
            <td>
              <div class="overflow-text">
                {{address.ConsigneeName}}
              </div>
            </td>
            <td>
              <div class="overflow-text">
                {{address.ConsigneeCompany}}
              </div>
            </td>
            <td>
              <div class="overflow-text">
                {{address.Address}}
              </div>
            </td>
            <td>
              <div class="overflow-text">
                {{address.GroupId}}
              </div>
            </td>
            <td>
              <div>
                <p-dropdown [filter]="true" [options]="countryOptions" appendTo="body" [(ngModel)]="address.Country"
                  (onChange)="mergeCountryChange($event, address)" [disabled]="true"></p-dropdown>
              </div>
            </td>
            <td>
              <p-dropdown [options]="address.cityOptions" appendTo="body" [(ngModel)]="address.City"
                (onChange)="mergeCityChange($event, address)" [filter]="true" filterBy="label" [disabled]="true"></p-dropdown>
            </td>
            <td>
              <textarea [rows]="5" pInputTextarea [(ngModel)]="address.DeliveryToLocalName" [autoResize]="true" class="p-inputtext-sm" style="width:90%; max-height:200px" readonly></textarea>
            </td>
            <td class="copy-address-wrapper">
              <textarea [rows]="5" pInputTextarea [(ngModel)]="address.LocalAddress" [autoResize]="true" class="p-inputtext-sm" style="width:90%; max-height:200px" readonly></textarea>
              <button type="button" class="copy-address-btn" pButton icon="pi pi-copy" (click)="copyToClipboard(address.LocalAddress)" [attr.aria-label]="'Common.Button.Copy' | translate"></button>
            </td>
            <td>
              <textarea [rows]="5" pInputTextarea [(ngModel)]="address.DeliveryToEngName" [autoResize]="true" class="p-inputtext-sm" style="width:90%; max-height:200px" readonly></textarea>
            </td>
            <td class="copy-address-wrapper">
              <textarea [rows]="5" pInputTextarea [(ngModel)]="address.EngAddress" [autoResize]="true" class="p-inputtext-sm" style="width:90%; max-height:200px" readonly></textarea>
              <button type="button" class="copy-address-btn" pButton icon="pi pi-copy" (click)="copyToClipboard(address.EngAddress)" [attr.aria-label]="'Common.Button.Copy' | translate"></button>
            </td>
            <td>
              <p-dropdown [options]="address.districtOptions" appendTo="body" [(ngModel)]="address.AssignmentDistrictId"
                  [filter]="true" filterBy="label" [disabled]="true"></p-dropdown>
            </td>
            <td>
              <div>
                <p-dropdown [filter]="true" [options]="address.airportOptions" appendTo="body" [(ngModel)]="address.Airport" [disabled]="this.isAirportDisabled">
                </p-dropdown>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>

  <ng-template #insertAddressContent>
    <div style="height: 60vh; overflow-y: auto; overflow-x: hidden;">
      <div class="p-fluid formgrid grid mt-4">
        <div class="field col-6">
          <label class="title">{{'Address.Header.CustomerName' | translate}}</label>
          <div>
              {{currentConsigneeName}}
          </div>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.Country' | translate}}</label>
          <div>
              <p-dropdown [filter]="true" filterBy="label,value" [options]="countryOptions" appendTo="body" [(ngModel)]="insertForm.countrySelected" (onChange)="insertFormCountryChange($event)"></p-dropdown>
          </div>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.City' | translate}}</label>
          <div>
              <p-dropdown [filter]="true" filterBy="label" [options]="insertForm.cityOptions" appendTo="body" [(ngModel)]="insertForm.city" (onChange)="insertFormCityChange($event)"></p-dropdown>
          </div>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.DeliveryToLocal' | translate}}</label>
          <div>
              <input type="text" [(ngModel)]="insertForm.deliveryToLocalName" pInputText class="p-inputtext-sm">
          </div>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.DeliveryToEng' | translate}}</label>
          <laas-input-set [maxlength]="maxChars" [(ngModel)]="insertForm.deliveryToEngName" ></laas-input-set>
        </div>

        <div class="field col-6">
          <label class="title">{{'Address.Header.Airport' | translate}}</label>
          <div>
            <p-dropdown [filter]="true" [options]="insertForm.airportOptions" appendTo="body" [(ngModel)]="insertForm.airport"></p-dropdown>
          </div>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.NormalizationLocal' | translate}}</label>
          <div>
              <textarea [rows]="5" [cols]="30" pInputTextarea [(ngModel)]="insertForm.localAddress" [autoResize]="true" class="p-inputtext-sm"></textarea>
              <!-- <input type="text" [(ngModel)]="insertForm.localAddress" pInputText class="p-inputtext-sm"> -->
          </div>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.NormalizationEng' | translate}}</label>
          <laas-text-area-set [row]="5" [col]="30" [maxlength]="maxCharsForNormalize" [(ngModel)]= "insertForm.engAddress"></laas-text-area-set>
        </div>
        <div class="field col-6">
          <label class="title">{{'Address.Header.AssignmentDistricId' | translate}}</label>
          <p-dropdown [filter]="true" filterBy="label" [options]="insertForm.districtOptions" appendTo="body" [(ngModel)]="insertForm.districtSelected"></p-dropdown>
        </div>
      </div>
    </div>
  </ng-template>

  <p-footer style="display: flex; margin-top: 1rem;">
    <div *ngIf="confirmType == 1 then mergeAddressFooter else insertAddressFooter"></div>
    <ng-template #mergeAddressFooter>
      <button pButton (click)="mergeAddress($event)" pRipple [label]="getConfirmButtonLabel()"></button>
    </ng-template>
    <ng-template #insertAddressFooter>
      <button (click)="insertAddress($event)" pButton pRipple [label]="getConfirmButtonLabel()"></button>
    </ng-template>
  </p-footer>
</p-dialog>

<laas-same-address-apply
  [display]="showSameAddressDialog"
  [candidates]="sameAddressCandidates"
  [lookbackDays]="sameAddressLookbackDays"
  (selectionChanged)="onSameAddressSelectionChanged($event)">
</laas-same-address-apply>
